import React, { useState, useEffect } from "react";
import "../../components/City/City.css";
import axios from "axios";

const City = ({tokenStorage,openProfile,setOpenProfile,selectedCityId}) => {
  const [countryResponse, setCountryResponse] = useState([]);
  const [stateResponse, setStateResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);
    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETCity?cityID=`+selectedCityId+`&stateID=0` ,
          
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const [firstItem, setFirstItem] = useState({
    id:selectedCityId,
    state_id: "",
    name: "",
    country_id:"",
    stateName: "",
    countryname:"",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setFirstItem({
      id: selectedCityId,
    });
  
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddCity`,
        {
          id: firstItem.id,
        state_id: firstItem.state_id,
        country_id: firstItem.country_id,
        name: firstItem.name
        }, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      // Optionally, reset the form
      setFirstItem({
        name: "",
      });
      tokenStorage();
      setOpenProfile (!openProfile);
   
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  useEffect (()=>{
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETCountry?countryID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setCountryResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

        axios
        .get(
          `${baseAPI}adminget/GETState?stateID=0&countryID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setStateResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  },[]);

  return (
    <div className="container-fluid">
      <br />

      <div className="cityDetail">
        <form className="city-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Country Name*</td>
              <td>State Name*</td>
              <td>City Name*</td>
            </tr>

            <tr>
              <td>
                <select className="dropdown-country"
                name="country_id"
                value={firstItem.country_id}
                onChange={handleChange} >
                  <option className="dropdown-country" value="">Select your option</option>
                  {countryResponse.map((item)=>(

                  <option value={item.id}>{item.name}</option>
                  ))} 
                </select>
              </td>
              <td>
                <select className="dropdown-state"
                name="state"
                value={firstItem.state_id}
                onChange={handleChange}>
                  <option className="dropdown-state" value="">Select your option</option>
                  {stateResponse.map((item)=>(
                   <option value={item.state_id}>{item.stateName}</option>

                  ))}
                </select>
              </td>
              <td>
                <input type="text"
                  name="name"
                  value={firstItem.name}
                  placeholder="Enter Please" 
                  onChange={handleChange}
                  />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addCity-button">
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Apply
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default City;
